import { Info } from "lucide-react";
import { Tooltip } from "@/components/ui/Tooltip";

/**
 * The "(i)" of the wnioski engine: a small info icon with an instructional
 * tooltip. Every phase/section header carries one, explaining step-by-step what
 * to do and where the data comes from.
 */
export function InfoHint({ text, className }: { text: string; className?: string }) {
  if (!text) return null;
  return (
    <Tooltip content={text} className={className}>
      <span className="inline-flex items-center text-[var(--color-text-muted)] hover:text-[var(--color-primary)] cursor-help align-middle">
        <Info size={13} />
      </span>
    </Tooltip>
  );
}
